import { usePermissions } from 'features/permissions/usePermissions';
import { PermissionTypes } from 'features/permissions/types';
import { useFeatureFlag } from 'features/feature-set/useFeatureFlag';
import { canAccessSharedNotes } from 'features/shared-notes/canAccessSharedNotes';
import { useSystemSession } from 'hooks/useSystemSession';

export const useSharedNotes = () => {
  const { hasPermissions } = usePermissions();
  const isSystemSession = useSystemSession();
  const isFeatureEnabled = useFeatureFlag('sharedNotes');

  const canEditNotes = hasPermissions(PermissionTypes.collaborateInNotes);
  const canSeeNotes = hasPermissions(PermissionTypes.seeNotes);

  const isFeatureAvailable = canAccessSharedNotes({
    sharedNotesEnabled: isFeatureEnabled,
    canSeeNotes,
    canEditNotes,
    isSystemSession,
  });

  return {
    isFeatureAvailable,
    canSeeNotes,
    canEditNotes,
  };
};
